<mat-accordion #accordion="matAccordion">
  <mat-expansion-panel
    hideToggle
    [expanded]="false"
    (opened)="handleExpandResume()"
  >
    <mat-expansion-panel-header>
      <mat-panel-title> Resumen </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="detail-body">
      @if(item$ | async; as item) {
      <ng-container *ngTemplateOutlet="row; context: { item }"></ng-container>
      }@else {
      <ng-container *ngTemplateOutlet="noData"></ng-container>
      }
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel
    hideToggle
    [expanded]="false"
    (opened)="handleExpandHistory()"
  >
    <mat-expansion-panel-header>
      <mat-panel-title> Historial de cambios</mat-panel-title>
    </mat-expansion-panel-header>

    @if(hasDetail$ | async; as hasDetail) {
    <div class="detail-body flex">
      <div class="panel-left w-1/2 px-4">
        <ng-container *ngTemplateOutlet="history"></ng-container>
      </div>
      <div class="panel-right w-1/2 h-full flex">
        @if(detail$ | async; as detail) {
        <mat-tab-group>
          <mat-tab label="Detalle">
            <table class="min-w-full w-full border border-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    class="px-4 py-2 text-left text-sm font-medium text-gray-900 border-b"
                  >
                    Propiedad
                  </th>
                  <th
                    class="px-4 py-2 text-left text-sm font-medium text-gray-900 border-b"
                  >
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (entry of getObjectEntries(detail); track entry.key) {
                <tr class="hover:bg-gray-50">
                  <td
                    class="px-4 py-2 text-sm font-medium text-gray-900 border-b border-gray-200"
                  >
                    {{ entry.key }}
                  </td>
                  <td
                    class="px-4 py-2 text-sm text-gray-700 border-b border-gray-200"
                  >
                    @if (isObject(entry.value)) {
                    <span class="text-blue-600 italic">[Objeto]</span>
                    } @else if (isArray(entry.value)) {
                    <span class="text-green-600 italic"
                      >[Array({{ getArrayLength(entry.value) }})]</span
                    >
                    } @else {
                    {{ formatValue(entry.value) }}
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </mat-tab>

          <mat-tab label="JSON">
            <pre class="bg-gray-100 p-4 rounded text-sm overflow-auto">{{
              detail | json
            }}</pre>
          </mat-tab>
        </mat-tab-group>

        }
      </div>
    </div>
    } @else {
    <div class="detail-body">
      <div class="panel-left w-full">
        <ng-container *ngTemplateOutlet="history"></ng-container>
      </div>
    </div>
    }
  </mat-expansion-panel>
</mat-accordion>

<ng-template #noData>
  <div class="block-detail">
    <span class="detail-title">Sin datos</span>
  </div>
</ng-template>

<ng-template #blockDetail let-title="title" let-description="description">
  @if(description){
  <div class="block-detail">
    <span class="detail-title">{{ title }}:</span>&nbsp;
    <span class="detail-description" [matTooltip]="$any(description)">
      {{ description }}
    </span>
  </div>
  }
</ng-template>

<ng-template #row let-item="item">
  <ng-container
    *ngTemplateOutlet="
      blockDetail;
      context: {
        title: 'Creado',
        description:
          (item.createdAt | date : 'dd/MM/yyyy HH:mm:ss') +
          '&nbsp;' +
          item.createdByEmail +
          '&nbsp;(' +
          item.createdBy +
          ')'
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      blockDetail;
      context: {
        title: 'Actualizado',
        description: item.updatedAt
          ? (item.updatedAt | date : 'dd/MM/yyyy HH:mm:ss') +
            '&nbsp;' +
            item.updatedByEmail +
            '&nbsp;(' +
            item.updatedBy +
            ')'
          : null
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      blockDetail;
      context: {
        title: 'Borrado',
        description: item.deletedAt
          ? (item.deletedAt | date : 'dd/MM/yyyy HH:mm:ss') +
            '&nbsp;' +
            item.deletedByEmail +
            '&nbsp;(' +
            item.deletedBy +
            ')'
          : null
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      rowBase;
      context: {
        item: item
      }
    "
  ></ng-container>
</ng-template>

<ng-template #rowHistory let-item="item">
  <ng-container
    *ngTemplateOutlet="
      blockDetail;
      context: {
        title: 'Secuencia',
        description: item.seq
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      blockDetail;
      context: {
        title: 'Cuando',
        description: item.modifiedAt
          ? (item.modifiedAt | date : 'dd/MM/yyyy HH:mm:ss') +
            '&nbsp;' +
            item.modifiedByEmail +
            '&nbsp;(' +
            item.modifiedBy +
            ')'
          : null
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      blockDetail;
      context: {
        title: 'Acción',
        description: item.action
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      rowBase;
      context: {
        item: item
      }
    "
  ></ng-container>
</ng-template>

<ng-template #rowBase let-item="item">
  <ng-container
    *ngTemplateOutlet="
      blockDetail;
      context: {
        title: 'Versión',
        description: item.version
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      blockDetail;
      context: {
        title: 'Trazabilidad',
        description: [item.traceabilityId, item.clientIp]
          .filter(filter)
          .join(' - ')
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      blockDetail;
      context: {
        title: 'Sistema',
        description: [
          item.beVersion ? 'BE ' + item.beVersion : undefined,
          item.meVersion ? 'ME ' + item.meVersion : undefined,
          item.feVersion ? 'FE ' + item.feVersion : undefined
        ]
          .filter(filter)
          .join(' - ')
      }
    "
  ></ng-container>
</ng-template>

<ng-template #history>
  @if(history$ | async; as history) { @for (item of history; track item; let
  isLast = $last) {
  <div
    class="p-4"
    [class.border]="(activeDetail$ | async) === item.seq"
    [class.border-gray-500]="(activeDetail$ | async) === item.seq"
  >
    <ng-container
      *ngTemplateOutlet="rowHistory; context: { item }"
    ></ng-container>
    <div class="block-detail text-right hidden">
      <button matButton (click)="handleViewDetail(item)">Ven detalle</button>
    </div>
  </div>
  @if(!isLast) {
  <mat-divider></mat-divider>
  } } @empty {
  <ng-container *ngTemplateOutlet="noData"></ng-container>
  } }
</ng-template>
